<template>
  <div class="withdraw">
    <Navbar title="提现"/>
    <div class="withdraw-top clearfix topBg">
      <div class="balance">当前余额￥{{ balance }}，<span @click="amount=balance">全部提现</span></div>
      <div class="input">
        <input type="text" placeholder="请输入提现金额" v-model="amount" @input="limitNum(amount)">
      </div>
    </div>
    <div class="explain">
      <p>提现说明：</p>
      <p>1、待工作人员确认后，提现金额将依据原充值渠道原路退回</p>
    </div>
    <div class="submit">
      <button class="themeColor" @click="getOrderWithdrawal">确认</button>
    </div>
  </div>
</template>

<script>
import Navbar from "../../components/NavBar";
import {Toast} from "vant";

export default {
  name: "withdraw",
  components: {Navbar},
  data() {
    return {
      amount: '',
      balance: ''
    }
  },
  mounted() {
    this.getUserInfo()
  },
  methods: {
    getUserInfo() {
      this.$post('user/info').then(res => {
        if (res.status == 200) {
          this.balance = res.data.balance || '0.00'
        }
      })
    },
    getOrderWithdrawal() {
      let amount = this.amount
      if (amount == '') {
        return Toast('请输入提现金额')
      } else if (amount == '0' || amount == '0.' || amount == '0.0' || amount == '0.00') {
        return Toast('请输入正确的提现金额')
      }
      this.$post('order/withdrawal', {amount}).then(res => {
        if (res.status == 200) {
          this.getUserInfo()
          this.amount = ''
          return Toast.success('提现成功')
        } else {
          return Toast.fail(res.msg)
        }
      })
    },
    limitNum(amount) {
      amount = amount
          .replace(/[^\d.]/g, "") //只能输入数字
          .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3") //只能输入两个小数
          .replace(/\.{2,}/g, "."); //出现多个点时只保留第一个
      // 第一位不让输小数点
      if (amount == ".") {
        amount = "";
      }
      // 如果第一位是0，第二位必须大于0或者小数点
      if (amount.substring(0, 1) == 0) {
        if (amount.substring(1, 2) > 0) {
          amount = amount.substring(1, 2);
        } else if (
            amount.substring(1, 2) === 0 ||
            amount.substring(1, 2) === "0"
        ) {
          amount = "0";
        }
      } else {
        // 如果第一位数字大于0（不等于0肯定就大于0），仅需考虑第二位是小数点的情况
        if (amount.indexOf(".") !== -1) {
          if (amount.substring(0, 1) > 0) {
            console.log("第一位大于0");
          } else {
            console.log("第一位等于0");
            if (amount.substring(2, 3) > 0) {
              console.log("小数点后第一位大于0");
            } else {
              console.log("小数点后第一位等于0");
              amount = "0.";
            }
          }
        } else {
          console.log("没有小数点，正常输入");
        }
      }
      this.amount = amount;
    },
  }
}
</script>

<style scoped lang="less">
.withdraw {
  height: 100vh;
  position: relative;
  font-size: 14px;

  .withdraw-top {
    height: 200px;

    .balance {
      margin-top: 20px;
      text-align: center;
    }

    .input {
      width: 100%;
      margin-top: 20px;
      display: flex;
      justify-content: center;
      padding: 0 15px;
      box-sizing: border-box;
      color: #000000;

      input {
        width: 100%;
        height: 55px;
        background: #FFFFFF;
        border-radius: 8px;
        border: none;
        text-align: center;
        font-size: 18px;
      }
    }
  }

  .explain {
    padding: 0 15px;
    color: #666666;
    line-height: 20px;
    margin-top: -42px;
  }

  .submit {
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;
    position: absolute;
    bottom: 15px;

    button {
      width: 100%;
      height: 50px;
      border: none;
      border-radius: 25px;
      font-size: 18px;
      font-weight: bold;
    }
  }
}
</style>